import * as React from "react";
import Divider from "@adsk/alloy-react-divider";

/**
 * the divider line sometimes wants to be longer than 100%, by a certain
 * specific amount (e.g. to compensate for padding in a panel)
 */
export const DividerLine = ({
  extendPx,
  margin,
}: {
  extendPx?: number;
  margin?: number;
}) => {
  const verticalMargin = `${margin !== undefined ? margin : 0}px`;
  const style = {
    minHeight: "1px",
    width: extendPx !== undefined ? `calc(100% + ${2 * extendPx}px)` : "100%",
    marginLeft: extendPx !== undefined ? `calc(${extendPx}px * -1)` : "0px",
    marginTop: verticalMargin,
    marginBottom: verticalMargin,
  };
  return <Divider style={style} />;
};
